import { createContext, useContext } from "react";
import type { LinkedEmployeeState } from "@/hooks/useLinkedEmployee";
import type { EmployeeFunctionalCapacityGateState } from "@/hooks/useEmployeeFunctionalCapacityGate";

export type EmployeeSessionContextValue = {
  linked: LinkedEmployeeState;
  fcGate: EmployeeFunctionalCapacityGateState;
};

export const EmployeeSessionContext = createContext<EmployeeSessionContextValue | null>(null);

export function useEmployeeSessionContext(): EmployeeSessionContextValue | null {
  return useContext(EmployeeSessionContext);
}
